function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import React, { useState } from "react";
import cx from "classnames";
import { SolutionCubesSVG } from "./SolutionCubesSVG";
import { IconDetailsGridCard, Section } from "../../molecules";
import { Heading, Subheading } from "../../atoms";
export var DynamicSVGComponent = function(param) {
    var bubblesIconDetailsGridCards = param.bubblesIconDetailsGridCards, title = param.title, label = param.label, enableLines = param.enableLines, className = param.className, darkbackground = param.darkbackground;
    var ref = _slicedToArray(useState("CISO_bubble"), 2), hoveredCircleId = ref[0], setHoveredCircleId = ref[1];
    var hoveredBubble = bubblesIconDetailsGridCards.find(function(b) {
        return b.solution_code === hoveredCircleId;
    });
    var bgColor = darkbackground ? "offdefault" : "default";
    return /*#__PURE__*/ React.createElement(Section, {
        container: true,
        lines: enableLines ? "dark" : false,
        className: className,
        linesClassName: "z-20",
        backgroundColor: bgColor
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "hidden lg:block"
    }, !!label && /*#__PURE__*/ React.createElement(Subheading, {
        className: cx("primary text-brand-primary-base")
    }, label), !!title && /*#__PURE__*/ React.createElement(Heading, {
        as: "h2",
        variant: "h2"
    }, title), /*#__PURE__*/ React.createElement("div", {
        className: ""
    }, " ", /*#__PURE__*/ React.createElement("div", {
        className: "flex"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-2/3 bg-white"
    }, /*#__PURE__*/ React.createElement("p", null, /*#__PURE__*/ React.createElement(SolutionCubesSVG, {
        hoveredCircleId: hoveredCircleId,
        onCircleHover: setHoveredCircleId
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "w-1/3 bg-white ml-4 pl-5"
    }, /*#__PURE__*/ React.createElement("p", null, hoveredBubble ? /*#__PURE__*/ React.createElement(IconDetailsGridCard, {
        icon: hoveredBubble.icon,
        title: hoveredBubble.title,
        description: hoveredBubble.description,
        callToAction: hoveredBubble.callToAction
    }) : "")))))));
};

//# sourceMappingURL=DynamicSVGComponent.js.map